module.exports = __webpack_public_path__ + "assets/img/LIFE.9cb7011b.png";